export default "__VITE_ASSET__CAs_VQWr__"